export type DisplayMode = 'vertical-kiosk' | 'landscape' | 'portrait';
export type PortraitOrientation = 'vertical' | 'horizontal';

export interface GridLayout {
  columns: number;
  rows: number;
}

export function displayModeFromFlags(
  isVerticalKiosk: boolean,
  viewportIsPortrait: boolean
): DisplayMode {
  if (isVerticalKiosk) {
    return 'vertical-kiosk';
  }
  return viewportIsPortrait ? 'portrait' : 'landscape';
}

export function pickGridLayout(
  displayMode: DisplayMode,
  orientation: PortraitOrientation,
  landscapePerSlide = 3
): GridLayout {
  if (displayMode === 'vertical-kiosk') {
    return orientation === 'horizontal'
      ? { columns: 1, rows: 3 }
      : { columns: 2, rows: 2 };
  }

  if (displayMode === 'portrait') {
    return { columns: 1, rows: 1 };
  }

  return orientation === 'horizontal'
    ? { columns: 2, rows: 1 }
    : { columns: landscapePerSlide, rows: 1 };
}
